// App.jsx
import React from 'react';
import Home from './pages/Home';

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Home />
    </div>
  );
}

export default App;